import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        if (window.innerWidth < 700) {
            this.menuAccordions()
        }

        window.addEventListener('resize', () => {
            if (window.innerWidth < 700) {
                this.menuAccordions()
            } else {
                document.querySelectorAll('.c-site-map.-footer .js-accordion-menu-content').forEach((item) => {
                    item.style.height = 'auto'
                    item.parentNode.classList.remove('is-active')
                })
            }
        })
    }

    menuAccordions() {
        this.el.querySelectorAll('.c-site-map.-footer .js-accordion-menu-item').forEach((item) => {
            item.querySelector('.js-accordion-menu-content').style.height = '0px'
            item.classList.remove('is-active')

            item.querySelectorAll('.js-accordion-menu-header').forEach((item) => {
                item.removeEventListener('click', this.accordionClick)
                item.addEventListener('click', this.accordionClick)
            })
        })
    }

    accordionClick(e){
        let item = e.currentTarget
        const content = item.parentNode.querySelector('.js-accordion-menu-content')
        if (content.style.height === '0px') {
            content.style.height = content.scrollHeight + 'px'
            item.parentNode.classList.add('is-active')
        } else {
            content.style.height = '0px'
            item.parentNode.classList.remove('is-active')
        }
        document.querySelectorAll('.c-site-map.-footer .js-accordion-menu-content').forEach((item) => {
            if (item !== content) {
                item.style.height = '0px'
                item.parentNode.classList.remove('is-active')
            }
        })
    }

    destroy() {
        //item.removeEventListener('click', this.accordionClick)
    }
}
